<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main" v-loading="tableLoading">
          <div class="mainbody">
            <h3 class="title">管理员设置</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <el-table :data="admin_list">
                <el-table-column
                  prop="id"
                  label="编号"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  label="管理员姓名"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="user"
                  label="账号"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="template_cn"
                  label="所属角色"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="create_time"
                  label="创建时间"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="status"
                  label="状态"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="operating"
                  label="操作"
                  min-width="2"
                  align="left"
                >
                  <template slot-scope="scope">
                    <el-button
                      class="operateText"
                      size="mini"
                      type="text"
                      @click="adminResetPwd(scope.row)"
                      >重置密码</el-button
                    >
                    <el-button
                      class="operateText"
                      size="mini"
                      type="text"
                      @click="adminEdit(scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      class="operateText"
                      size="mini"
                      type="text"
                      @click="adminDelete(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="addData_bor">
                <el-button @click="adminAdd()" type="text" class="addData_style"
                  >+&nbsp;&nbsp;新增管理员</el-button
                >
              </div>
            </div>
            <h3 class="title tableInfo_margin">角色管理</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <el-table :data="role_list">
                <el-table-column
                  prop="id"
                  label="编号"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="template_cn"
                  label="角色类型"
                  min-width="1"
                ></el-table-column>
                <el-table-column prop="api_list" label="权限" min-width="2">
                  <template slot-scope="scope">
                    <p class="listP" style="white-space: pre-line">{{ scope.row.api_list_cn }}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="create_time"
                  label="创建时间"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="status"
                  label="状态"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="operating"
                  label="操作"
                  min-width="2"
                  align="left"
                >
                  <template slot-scope="scope">
                    <el-button
                      class="operateText"
                      :disabled="scope.row.id == 0"
                      size="mini"
                      type="text"
                      @click="roleEdit(scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      class="operateText"
                      :disabled="scope.row.id == 0"
                      size="mini"
                      type="text"
                      @click="roleDelete(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="addData_bor">
                <el-button @click="roleAdd()" type="text" class="addData_style"
                  >+&nbsp;&nbsp;新增角色</el-button
                >
              </div>
            </div>
          </div>
        </el-main>

        <admin-add-dialog
          ref="_adminAddDialog"
          @toSave="adminUserList"
        ></admin-add-dialog>
        <admin-reset-pwd-dialog
          ref="_adminResetPwdDialog"
        ></admin-reset-pwd-dialog>
        <admin-update-dialog
          ref="_adminUpdateDialog"
          @toSave="adminUserList"
        ></admin-update-dialog>
        <role-add-dialog
          ref="_roleAddDialog"
          @toSave="powerTemplateList"
          @showPower="showPowerDialog"
          @closePower="closePowerDialog"
          :api-list-array="apiListArray"
        ></role-add-dialog>
        <role-update-dialog
          ref="_roleUpdateDialog"
          @toSave="roleUpdateSave"
          @showPower="showPowerDialog"
          @closePower="closePowerDialog"
          :api-list-options="apiListOptions"
        ></role-update-dialog>
        <role-power-dialog
          ref="_rolePowerDialog"
          @toSave="saveSelectPower"
          :api-list-array="apiListArray"
        ></role-power-dialog>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import { URL_PATH } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayout";
import adminAddDialog from "@/components/dialog/adminAddDialog";
import adminResetPwdDialog from "@/components/dialog/adminResetPwdDialog";
import adminUpdateDialog from "@/components/dialog/adminUpdateDialog";
import roleAddDialog from "@/components/dialog/roleAddDialog";
import roleUpdateDialog from "@/components/dialog/roleUpdateDialog";
import rolePowerDialog from "@/components/dialog/rolePowerDialog";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    adminAddDialog,
    adminResetPwdDialog,
    adminUpdateDialog,
    roleAddDialog,
    roleUpdateDialog,
    rolePowerDialog,
  },
  data() {
    return {
      meunItem: null,
      tableLoading: false,
      meunTitle: "管理员权限设置",
      URL_PATH: URL_PATH,
      // editToken: "", //编辑用户信息的token
      ais_info: {}, //个人信息
      updateTimeStamp: "",
      apiListArray: [], //api列表
      apiListOptions: [], //api列表
      admin_list: [], //管理员列表
      role_list: [], // 角色列表
      ais_journal: [], //捐助信息
      ais_honor: [], //荣誉信息
      labelPosition: "top",
      aisInfoStatusOptions: Constant.work_status_options,
    };
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      this.getList();
    },
    // 获取管理员列表
    adminUserList: function () {
      this.$api
        .adminUserList({
          token: localStorage.getItem("token"),
        })
        .then(({ data }) => {
          this.admin_list = data.Data;
          this.admin_list.forEach((admin) => {
            admin.status = StrUtils.getAdminState(admin.status);
          });
        })
        .catch(({ error }) => {});
    },
    // 获取角色列表
    powerTemplateList: function () {
      this.$api
        .powerTemplateList({
          token: localStorage.getItem("token"),
        })
        .then(({ data }) => {
          this.role_list = data.Data;
          this.role_list.forEach((role) => {
            // role.api_list = this.getApiList(role.api_list);
            role.api_list_cn = this.getApiListCn(role);
            role.status = StrUtils.getAdminState(role.status);
          });
        })
        .catch(({ error }) => {});
    },
    getList: function () {
      this.adminUserList();
      this.apiList();
    },
    // 获取接口列表
    apiList: function () {
      this.$api
        .apiList({
          token: localStorage.getItem("token"),
        })
        .then(({ data }) => {
          this.apiListArray = data.Data;
          this.apiListOptions = [];

          this.apiListArray.forEach((array) => {
            array.api_list.forEach((api) => {
              this.apiListOptions.push({
                value: api.id,
                label: api.api_cn,
              });
            });
          });
          this.powerTemplateList();
        })
        .catch(({ error }) => {});
    },
    // 管理员重置密码
    adminResetPwd(info) {
      this.$api
        .resetPasswdVerify({
          token: localStorage.getItem("token"),
          admin_id: info.id,
        })
        .then(({ data }) => {
          this.$nextTick(() => {
            this.$refs._adminResetPwdDialog.show(info.id);
          });
        })
        .catch(({ error }) => {});
    },
    // 管理员编辑
    adminEdit(info) {
      this.$api
        .updateAdminUserVerify({
          token: localStorage.getItem("token"),
          admin_id: info.id,
        })
        .then(({ data }) => {
          this.$nextTick(() => {
            this.$refs._adminUpdateDialog.show(data.Data);
          });
        })
        .catch(({ error }) => {});
    },
    // 管理员删除
    adminDelete(info) {
      this.$confirm("是否删除此管理员?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$api
            .delAdminUser({
              token: localStorage.getItem("token"),
              admin_id: info.id,
            })
            .then(({ data }) => {
              this.adminUserList();
            })
            .catch(({ error }) => {});
        })
        .catch(() => {});
    },
    // 新增管理员
    adminAdd() {
      Api.verifyApi(CApi.api_createAdminUser, (verify) => {
        if (verify) {
          this.$nextTick(() => {
            this.$refs._adminAddDialog.show();
          });
        }
      });
      // this.apiVerify(CApi.api_createAdminUser, (verify) => {
      //   if (verify) {
      //     this.$nextTick(() => {
      //       this.$refs._adminAddDialog.show();
      //     });
      //   }
      // });
    },
    // 角色编辑
    roleEdit(info) {
      Api.verifyApi(CApi.api_updatePowerTemplate, (verify) => {
        if (verify) {
          this.$nextTick(() => {
            this.$refs._roleUpdateDialog.show(info);
          });
        }
      });
    },
    // 角色删除
    roleDelete(info) {
      this.$confirm("是否删除此角色?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$api
            .delPowerTemplate({
              token: localStorage.getItem("token"),
              template_id: info.id,
            })
            .then(({ data }) => {
              this.powerTemplateList();
            })
            .catch(({ error }) => {});
        })
        .catch(() => {});
    },
    // 新增角色
    roleAdd() {
      Api.verifyApi(CApi.api_createPowerTemplate, (verify) => {
        if (verify) {
          this.$nextTick(() => {
            this.$refs._roleAddDialog.show();
          });
        }
      });
    },
    roleUpdateSave() {
      this.adminUserList();
      this.powerTemplateList();
    },
    // 显示权限选择框
    showPowerDialog(addPower, apiList) {
      this.$nextTick(() => {
        this.$refs._rolePowerDialog.show(addPower, apiList);
      });
    },
    // 取消权限选择框
    closePowerDialog() {
      this.$nextTick(() => {
        this.$refs._rolePowerDialog.resetData();
      });
    },
    // 权限选择
    saveSelectPower(addPower, powerids) {
      if (addPower) {
        this.$refs._roleAddDialog.setPowerIds(powerids);
      } else {
        this.$refs._roleUpdateDialog.setPowerIds(powerids);
      }
    },

    /**
     * 获取api列表
     */
    getApiListCn(role) {
      let apis = "";
      let api_list = role.api_list_cn;
      if (api_list == null) {
        apis = role.template_cn;
      } else {
        api_list.forEach((list) => {
          apis += list.name + "：\n";
          list.api.forEach((api) => {
            apis += "\xa0\xa0\xa0" + api.api_other_cn + "\n";
          });
        });
      }
      return apis;
    },
    getApiList(api_ids) {
      if (api_ids.indexOf(",") != -1) {
        let ids = api_ids.split(",");
        var api_cn = "";
        ids.forEach((id) => {
          const cn = this.getApiCn4Id(id);
          api_cn += cn + "\n";
        });
        return api_cn;
      } else {
        return this.getApiCn4Id(api_ids);
      }
    },
    getApiCn4Id(id) {
      let cn = "";
      this.apiListOptions.forEach((api) => {
        if (api.value === parseInt(id)) {
          cn = api.label;
          return;
        }
      });
      return cn;
    },
  },
};
</script>

<style lang="less" scoped>
.el-table__body-wrapper
  .el-table__body
  tbody
  .el-table__row
  td.el-table_2_column_10
  .cell {
  margin-top: -20px;
}
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.mainbody .tableInfo_margin {
  margin-top: 62px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.addData_bor {
  margin-top: 26px;
  border: 1px dashed #b1b1b1;
  border-radius: 4px;
  width: 100%;
  height: 32px;
  text-align: center;
}
.addData_bor .addData_style {
  font-size: 14px;
  color: #848484;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  height: 32px;
}
.operateText {
  font-size: 14px;
}
.apiList {
  background: #999;
}
</style>


// WEBPACK FOOTER //
// src/pages/dataMgr/adminSetting.vue